import Container from 'typedi'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import LearningModule from '@/modules/learning/index.module'
import CommonModule from '@/modules/common/index.module'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
    ...Container.get(CommonModule).routes(),
    ...Container.get(LearningModule).routes()
]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
})



export default router
